/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_sections/FormBreadcrumbs.tsx
 * Created:       Wed Apr 16 2025
 * Modified By:   Greg Olive
 * Last Modified: Wed Apr 16 2025
 */

import React, { useContext } from 'react';
import { TranslationsContext, FormContext } from "@proxy/_contexts";
import { getImageList, populatedCategories } from '@root/_utils';
import { Breadcrumbs } from "@proxy/_components";

const FormBreadcrumbs = () => {

  const translations = useContext(TranslationsContext);
  
  const {
    settings,
    bulkOrder,
    formData,
    currentStep,
    setCurrentStep,
    digitalEnabled,
    physicalEnabled,
    fulfillmentType,
  } = useContext(FormContext);

  const getBreadCrumbItems = () => {

    const categories = populatedCategories(settings, fulfillmentType);
    const categoryCount = categories ? categories.length : 0;
    const imageList = categoryCount > 0 ? getImageList(categories[0], settings, fulfillmentType) : [];
    const hasSingleImageOption = categoryCount <= 1 && imageList.length <= 1;
    const shouldShowDeliveryStep = (digitalEnabled && physicalEnabled && !bulkOrder);

    const items = [
      (shouldShowDeliveryStep) ? {
        label: translations.breadcrumb_card_delivery,
        value: "card_delivery",
        disabled: false,
        active: currentStep === "card_delivery",
      } : null,
      !hasSingleImageOption ? {
        label: translations.breadcrumb_greeting_card,
        value: "greeting_card",
        disabled: false,
        active: currentStep === "greeting_card",
      } : null,
      {
        label: translations.breadcrumb_gift_card,
        value: "gift_card",
        disabled: currentStep === "card_delivery",
        active: currentStep === "gift_card",
      }
    ];

    if (formData.properties._gcp_send_to_self !== true) {
      items.push({
        label: translations.breadcrumb_gift_message,
        value: "gift_message",
        disabled: true,
        active: currentStep === "gift_message",
      })
    }

    return items;

  };

  return (
    <Breadcrumbs
      currentStep={currentStep}
      setCurrentStep={setCurrentStep}
      items={getBreadCrumbItems()}
    />
  );
};

export default FormBreadcrumbs;
